import React, {Fragment} from 'react';
import {Drawer} from 'presentation/components/Drawer';
import {Timeline} from 'presentation/components/Timeline';
import {translations} from 'presentation/translations-new';
import {Box, Typography} from '@mui/material';
import {useTheme} from 'styled-components';
import {ErrorState, TagChip} from 'presentation/components';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {RefundStatusDrawerProps} from './types';
import {StyledBoxTitle} from './styles';
import {RefundStatusLoadingState} from '../RefundStatusLoadingState';
import {useProtocolStatus} from '../../queries/useProtocolStatus';

const {details, close, failToLoadTitle, failToLoadDescription, protocol} =
	translations['pt-br'].commons;

function RefundStatusDrawer({
	title,
	protocolCode,
	chip,
	openDrawer,
	onOpenDrawer,
	onCloseDrawer,
}: RefundStatusDrawerProps) {
	const theme = useTheme();
	const {
		data: timeline,
		isLoading,
		isError,
		isSuccess,
		refetch,
	} = useProtocolStatus(protocolCode);

	return (
		<Drawer.Root
			open={openDrawer}
			onClose={onCloseDrawer}
			onOpen={onOpenDrawer}
			width={'396px'}>
			<Fragment>
				<Drawer.Header
					onClose={onCloseDrawer}
					title={details}
					closeBtnDataTagId={
						RefundTaggingEnum.CLICK_ICONE_FECHAR_TRILHA_CONSULTAR_REEMBOLSO
					}
				/>
				<Drawer.Content>
					{isLoading ? <RefundStatusLoadingState /> : null}
					{isError ? (
						<ErrorState
							title={failToLoadTitle}
							description={failToLoadDescription}
							handleRefresh={refetch}
						/>
					) : null}
					{isSuccess ? (
						<Fragment>
							<StyledBoxTitle>
								<Typography variant="h6" color={theme.palette.primary.dark}>
									<Box component="span" fontWeight={400}>
										{protocol}
									</Box>{' '}
									{title}
								</Typography>
								<TagChip label={chip.chipText} color={chip.chipVariant} />
								<Typography variant="body2">{timeline.subtitle}</Typography>
							</StyledBoxTitle>
							{timeline.data && timeline.data.length > 0 ? (
								<Timeline content={timeline.data} />
							) : null}
						</Fragment>
					) : null}
				</Drawer.Content>
				<Drawer.Footer
					secondButtonDataTagId={
						RefundTaggingEnum.CLICK_BOTAO_FECHAR_TRILHA_CONSULTAR_REEMBOLSO
					}
					secondButtonTitle={close}
					secondButtonOnClick={onCloseDrawer}
					hideFirstButton
				/>
			</Fragment>
		</Drawer.Root>
	);
}

export {RefundStatusDrawer};
